import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Profileslistpay from "../wms/searchcustomerpay";
import { Button } from "reactstrap";
const ModalSearchpay = ({ header, onSelect ,isOpen,onCancel,search='',list  }) => {

  function handleUpdateData(value) {
     onSelect(value);
  }

  return (
    <>
      <Modal
          show={isOpen}
          onHide={onCancel}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
              ค้นหา {header}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Profileslistpay  
            list = {list}
            search = {search} 
            updateData={handleUpdateData}
             />
        
          </Modal.Body>
          <Modal.Footer>
            <Button
              type="primary"
              variant="danger"
              onClick={onCancel}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
   
    </>
  );
};

export default ModalSearchpay;
